"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tenure$ = exports.Tenure$outboundSchema = exports.Tenure$inboundSchema = void 0;
exports.tenureToJSON = tenureToJSON;
exports.tenureFromJSON = tenureFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const lease_js_1 = require("./lease.js");
const meta_js_1 = require("./meta.js");
const tenurevalues_js_1 = require("./tenurevalues.js");
/** @internal */
exports.Tenure$inboundSchema = z
    .object({
    lease_details: z.nullable(lease_js_1.Lease$inboundSchema),
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    tenure_type: z.nullable(tenurevalues_js_1.TenureValues$inboundSchema),
    tenure_type_predicted: z.nullable(z.boolean()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "lease_details": "leaseDetails",
        "tenure_type": "tenureType",
        "tenure_type_predicted": "tenureTypePredicted",
    });
});
/** @internal */
exports.Tenure$outboundSchema = z.object({
    leaseDetails: z.nullable(lease_js_1.Lease$outboundSchema),
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    tenureType: z.nullable(tenurevalues_js_1.TenureValues$outboundSchema),
    tenureTypePredicted: z.nullable(z.boolean()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        leaseDetails: "lease_details",
        tenureType: "tenure_type",
        tenureTypePredicted: "tenure_type_predicted",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Tenure$;
(function (Tenure$) {
    /** @deprecated use `Tenure$inboundSchema` instead. */
    Tenure$.inboundSchema = exports.Tenure$inboundSchema;
    /** @deprecated use `Tenure$outboundSchema` instead. */
    Tenure$.outboundSchema = exports.Tenure$outboundSchema;
})(Tenure$ || (exports.Tenure$ = Tenure$ = {}));
function tenureToJSON(tenure) {
    return JSON.stringify(exports.Tenure$outboundSchema.parse(tenure));
}
function tenureFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Tenure$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Tenure' from JSON`);
}
//# sourceMappingURL=tenure.js.map